import Vue from "vue";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
Vue.component("wto-ck-editor", {
    props: ["viewModelData", "hasSource", "toolbarItems", "placeholder", "readOnly"],
    computed: {
        computedValue: {
            get() {
                return !this.viewModelData ? "" : this.viewModelData;
            },
            set(value) {
                this.$emit("update:viewModelData", value);
            }
        },
        editorConfig() {
            let returnValue = {
                height: '10em',
                toolbar: {
                    items: ['bold', 'italic', 'subscript', 'superscript', 'link', '|', 'bulletedList', 'numberedList', 'outdent', 'indent', '|', 'undo', 'redo']
                },
            };



            if (this.hasSource) {
                returnValue = {
                    toolbar: {
                        items: ['bold', 'italic', 'subscript', 'superscript', 'link', '|', 'bulletedList', 'numberedList', 'outdent', 'indent', '|', 'sourceEditing', 'mediaEmbed', '|', 'undo', 'redo']
                    }
                };
            }

            if (this.toolbarItems) {
                returnValue.toolbar = this.toolbarItems.split(',');
            }

            if (this.readOnly) {
                returnValue.toolbar = [];
            }

            return returnValue;
        },
    },
    methods: {
    },
    data() {
        return {
            editor: ClassicEditor
        };
    },
    mounted() {
        if (this.readOnly) {
            //this.editor.ui.view.panel.element.setAttribute('style', 'display:none');
        }
    },
    template: `      
	   <ckeditor  :readonly="readOnly" :disabled="readOnly" tag-name="textarea" :editor="editor" v-model.lazy="computedValue" :config="editorConfig" :placeholder="placeholder"></ckeditor>
	`
});